// Room Configuration Index

import { Rooms } from '../config/room-types.js';
import { townRoom } from './town.js';
import { beachRoom } from './beach.js';
import { plazaRoom } from './plaza.js';
import { coveRoom } from './cove.js';
import { skiVillageRoom } from './ski-village.js';
import { skiHillRoom } from './ski-hill.js';
import { dockRoom } from './dock.js';
import { stadiumRoom } from './stadium.js';
import { forestRoom } from './forest.js';

export const rooms: Rooms = {
  town: townRoom,
  beach: beachRoom,
  plaza: plazaRoom,
  cove: coveRoom,
  'ski-village': skiVillageRoom,
  'ski-hill': skiHillRoom,
  dock: dockRoom,
  stadium: stadiumRoom,
  forest: forestRoom,
};
